import { 
  useCreateGroupMutation, 
  useDeleteGroupMutation, 
  useAddGroupToCourseMutation, 
  useRemoveGroupFromCourseMutation, 
  useUpdateGroupNameMutation 
} from '../groupsApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useGroupsActions = () => {
  const [createGroupTrigger] = useCreateGroupMutation();
  const [deleteGroupTrigger] = useDeleteGroupMutation();
  const [addGroupToCourseTrigger] = useAddGroupToCourseMutation();
  const [removeGroupFromCourseTrigger] = useRemoveGroupFromCourseMutation();
  const [updateGroupNameTrigger] = useUpdateGroupNameMutation();

  const createGroup = async (name) => {
    try {
      const result = await createGroupTrigger(name).unwrap();
      enqueueSnackbar(i18next.t('groups.groupCreated'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to create group';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const deleteGroup = async (id) => {
    try {
      const result = await deleteGroupTrigger(id).unwrap();
      enqueueSnackbar(i18next.t('groups.groupDeleted'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to delete group';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const addGroupToCourse = async ({ circleId, ucpPeriod, courseIds }) => {
    try {
      const result = await addGroupToCourseTrigger({ circleId, ucpPeriod, courseIds }).unwrap();
      enqueueSnackbar(i18next.t('groups.addCourseToGroup'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to add group to course';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const removeGroupFromCourse = async ({ courseId, circleId }) => {
    try {
      const result = await removeGroupFromCourseTrigger({ courseId, circleId }).unwrap();
      enqueueSnackbar(i18next.t('groups.removeCourseFromGroup'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to remove group from course';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const updateGroupName = async ({ id, name }) => {
    try {
      const result = await updateGroupNameTrigger({ id, name }).unwrap();
      enqueueSnackbar(i18next.t('groups.updateGroupName'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to update group name';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    createGroup,
    deleteGroup,
    addGroupToCourse,
    removeGroupFromCourse,
    updateGroupName,
  };
};
